import { render, staticRenderFns } from "./gateway-ips.vue?vue&type=template&id=5f14ad5e&scoped=true&"
import script from "./gateway-ips.vue?vue&type=script&lang=js&"
export * from "./gateway-ips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f14ad5e",
  null
  
)

export default component.exports